module.exports = __webpack_public_path__ + "static/media/mouse-alt.33d1913f.svg";